import React from 'react'
import ButtonComponent from '../../../../components/Buttons/ButtonComponent'
import TableEPL from '../TableEPL/TableEPL'
import { Grid, Stack } from '@mui/material'
import { showToast } from '../../../../components/ui'

const TabCostSSLine = (props) => {
  const title = 'Cost SSLine'
  const contactTypeName = 'SSLine'
  const contactTypeId = 4
  const income = false

  const handleAdd = () => {
    if (props.shipmentNo !== '') {
      props.handleAdd(title, contactTypeName, contactTypeId, income)
    }
    else {
      showToast({ type: 'error', message: 'Please Select Shipment Number First!' });
    }
  }

  const handleEdit = () => {
    if (props.selectedDetailCostSSLine.sequence === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' });
    } else {
      props.handleEdit(title, contactTypeName, contactTypeId, income)
    }
  }

  const handleConvert = () => {
    if (props.selectedDetailCostSSLine.sequence === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' });
    } else {
      props.handleConvert(title, contactTypeName, contactTypeId, income)
    }
  }

  const handleDoubleClick = () => {
    handleEdit()
  }

  const handleDelete = () => {
    if (props.selectedDetailCostSSLine.bookingDetailId === 0) {
      props.handleDelete(contactTypeId, income)
    }
    else {
      showToast({ type: 'error', message: 'Can\'t Delete This Data!' });
    }
  }

  return (
    <div className='rounded-10'>
      <TableEPL
        key={5}
        isReadOnly={props.isReadOnly}
        dataList={props.CostSSLineList}
        ignoreAccess={props.ignoreAccess}
        setDataList={props.setCostSSLineList}
        setSelectedDetail={props.setSelectedDetailCostSSLine}
        selectedDetail={props.selectedDetailCostSSLine}
        handleDoubleClick={handleDoubleClick}
        contactTypeName={contactTypeName}
        ttlUsd={props.estCostUSDSSLine}
        ttlIdr={props.estCostIDRSSLine}
        totalSData={props.totalCostSSSLine}
        totalNData={props.totalCostNSSLine}
        key1={5}
        key2={5}
        type={2}
        openClose={props.openCloseCS}
        setOpenClose={props.setOpenCloseCS}
        openClose2={props.openCloseCS2}
        setOpenClose2={props.setOpenCloseCS2}
        dataDetail={props.dataDetail}
        setDataDetail={props.setDataDetail}
        countSum={props.countSum}
        countTotalData={props.countTotalData}
      />

      <Grid container item direction="row" className='mt-3'>
        <Grid item xs={12}>
          <Stack direction={'row'} spacing={'10px'}>
            {ButtonComponent.AddButton(handleAdd, '', props.isReadOnly)}
            {ButtonComponent.EditButton(handleEdit, '', props.isReadOnly)}
            {ButtonComponent.DeleteButton(handleDelete, '', props.isReadOnly)}
            {ButtonComponent.ConvertButton(handleConvert, props.isReadOnly, true)}
          </Stack>
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(TabCostSSLine)